import { ComponentType, type IComponentSchema } from '../types';

export type SchemaMapping = Record<
  ComponentType,
  (props?: Partial<IComponentSchema<any>>) => IComponentSchema<any>
>;

const schemas = import.meta.glob('./*/schema.ts', { eager: true });
const manifests = import.meta.glob('./*/manifest.ts', { eager: true });

export const SCHEMA_MAPPING: SchemaMapping = Object.fromEntries(
  Object.entries(manifests).map(([path, mod]) => {
    const folder = path.split('/')[1];
    const key = (mod as any).default?.name ?? folder;
    const generateSchema = (schemas[`./${folder}/schema.ts`] as any)
      .generate as (
      props?: Partial<IComponentSchema<any>>
    ) => IComponentSchema<any>;
    return [key, generateSchema] as const;
  })
) as SchemaMapping;
